/**
 * The explicit answer for a data plane with no `env = 'prod'` keyword rows
 * (staging, A7Y-4883 D5). Never renders a zero: a zero would read as "the
 * corpus is empty" when the truth is "this plane does not hold the corpus".
 */
export function NoCountedRows({ dataset }: { dataset: string }) {
  return (
    <div
      data-testid="no-counted-rows"
      className="rounded-lg border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6 text-sm text-zinc-600 dark:text-zinc-300"
    >
      No counted rows on this data plane ({dataset}): the counting rule needs env = 'prod' rows, and{' '}
      {dataset} has none.
    </div>
  );
}
